export default __webpack_public_path__ + "PropaneHoverPin.png";